/**
 * @fileoverview Deep Link Analytics Hook
 *
 * Tracks deep link events and integrates with analytics service.
 *
 * @module hooks/useDeepLinkAnalytics
 */

import { useEffect } from 'react';
import { deepLinkService, type DeepLinkAnalyticsEvent } from '@/services/deepLink';

/**
 * Hook to track deep link analytics events
 *
 * Automatically subscribes to deep link events and logs them.
 * Integrate with your analytics service (e.g., Segment, Mixpanel, GA4).
 */
export function useDeepLinkAnalytics() {
  useEffect(() => {
    const unsubscribe = deepLinkService.onAnalytics((event: DeepLinkAnalyticsEvent) => {
      console.log('[Deep Link Analytics]', event);

      // Track with your analytics service
      // Example: analytics.track(event.event, {
      //   route_type: event.routeType,
      //   source: event.source,
      //   error: event.error,
      //   url: event.url,
      // });

      // Track specific events
      switch (event.event) {
        case 'deep_link_opened':
          console.log(`✅ Deep link opened: ${event.routeType} - ${event.url}`);
          break;

        case 'deep_link_failed':
          console.error(`❌ Deep link failed: ${event.error} - ${event.url}`);
          break;

        case 'deep_link_auth_required':
          console.log(`🔒 Deep link requires auth: ${event.routeType} - ${event.url}`);
          break;
      }
    });

    return unsubscribe;
  }, []);
}
